export default "__VITE_ASSET__qZ32AQ4D__"